/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COLOR PREVIEW - SENTIMENT CONFIGS : STYLES --------------- ++++++++++ */
export default {
    colorpreview: {
        flex: '1',
        '& .sectioncard': {
            minHeight: '100%',
            '& .previewcontainer': {
                width: '100%'
            }
        }
    }
};
